import type { IAdditionalProduct } from '~/modules/catalog/types/product';
import type { ICartLine } from '~/modules/cart/types/cart-types';

/**
 * Находит дополнительный продукт (услугу) по slug в списке additional_products строки корзины
 * @param line - строка корзины
 * @param slug - идентификатор услуги ('bracelet-size', 'engraving', 'packaging')
 * @returns дополнительный продукт или null, если не найден
 */
export const getAdditionalProductBySlug = (
  line: ICartLine,
  slug: string,
): IAdditionalProduct | null => {
  const additionalProducts = line.additional_products;
  if (!additionalProducts?.length) return null;
  return additionalProducts.find((p) => p.slug === slug) || null;
};
